import { Fragment } from 'react'
import { Card, Spinner } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { ChevronDown } from 'react-feather'
import ReactPaginate from 'react-paginate'
import { useDispatch } from 'react-redux'
import { setSelectedItem, toggleUpdatePopup, deleteCompanyIskurInfo } from './store'

// ** Columns
import { columns } from './columns'
import CustomHeader from './CustomHeader'

// ** Styles
import '@styles/react/libs/react-select/_react-select.scss'
import '@styles/react/libs/tables/react-dataTable-component.scss'

const Table = ({ 
  data, 
  total, 
  loading, 
  searchTerm, 
  rowsPerPage, 
  currentPage,
  handleFilter, 
  handlePerPage, 
  handlePagination,
  toggleSidebar 
}) => {
  const dispatch = useDispatch()

  // Edit handler
  const handleEdit = (item) => {
    dispatch(setSelectedItem(item))
    dispatch(toggleUpdatePopup(true))
  }

  // Delete handler
  const handleDelete = (id) => {
    if (window.confirm('Bu İŞKUR bilgisini silmek istediğinizden emin misiniz?')) {
      dispatch(deleteCompanyIskurInfo(id))
    }
  }

  // ** Custom Pagination
  const CustomPagination = () => {
    const count = Math.ceil(total / rowsPerPage)

    return (
      <ReactPaginate
        previousLabel={''}
        nextLabel={''}
        pageCount={count || 1}
        activeClassName='active'
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        onPageChange={page => handlePagination(page)}
        pageClassName={'page-item'}
        nextLinkClassName={'page-link'}
        nextClassName={'page-item next'}
        previousClassName={'page-item prev'}
        previousLinkClassName={'page-link'}
        pageLinkClassName={'page-link'}
        containerClassName={'pagination react-paginate justify-content-end my-2 pe-1'}
      />
    )
  }

  const dataToRender = () => {
    if (data.length > 0) {
      return data
    } else {
      return []
    }
  }

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f3f2f7',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderTopColor: '#e8e6ea',
        minHeight: '0',
        height: '38px'
      }
    },
    headCells: {
      style: {
        color: '#5e5873',
        fontWeight: 'bold',
        fontSize: '0.857rem',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem'
      }
    },
    cells: {
      style: {
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem'
      }
    }
  }

  return (
    <Fragment>
      <Card className='overflow-hidden'>
        <div className='react-dataTable'>
          <DataTable
            noHeader
            subHeader
            pagination
            responsive
            paginationServer
            columns={columns(handleEdit, handleDelete)}
            sortIcon={<ChevronDown />}
            className='react-dataTable'
            paginationComponent={CustomPagination}
            progressPending={loading}
            progressComponent={<Spinner type='grow' color='primary' />}
            data={dataToRender()}
            customStyles={customStyles}
            subHeaderComponent={
              <CustomHeader
                searchTerm={searchTerm}
                rowsPerPage={rowsPerPage}
                handleFilter={handleFilter}
                handlePerPage={handlePerPage}
                toggleSidebar={toggleSidebar}
              />
            }
          />
        </div>
      </Card>
    </Fragment>
  )
}

export default Table